import { Page } from '../../models/page.model';

export function wrapWithPage(data: Array<any>): Page<any> {
    return {
        data,
        total: data.length
    }
}